import { React, useState, useEffect } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import { useLanguage } from '../../../../Context/LanguageContext';

import PartnerGymHoldingAndExtendHistoryInfoView from './PartnerGymHoldingAndExtendHistoryInfoView';
import PartnerGymRefundInfoView from './PartnerGymRefundInfo';

const PartnerGymMemberShipHistoryInfoView = (props) => {
  const {
    data,
    index,
    size
  } = props;

  const { t } = useLanguage();

  const [fontColor, setFontColor] = useState('#595959');
  const [border, setBorder] = useState('1px solid #FFFFFF');
  const [hoverBorder, setHoverBorder] = useState('1px solid #FFFFFF');
  const [backgroundColor, setBackgroundColor] = useState('#FFFFFF');

  useEffect(() => {
    let startDate = moment(data.startDate);
    let endDate = moment(data.endDate);

    // 환불 데이터의 경우 //
    if (data.isRefund) {
      setFontColor('#777777');
      setBorder('1px solid #F8F8F8');
      setHoverBorder('1px solid #FF8B48');
      setBackgroundColor('#F8F8F8');
    }
    // 결제 예정 데이터 정리 //
    else if (data.isExpectedMemberShip) {
      setFontColor('#777777');
      setBorder('1px solid #FDECC1');
      setHoverBorder('1px solid #FF8B48');
      setBackgroundColor('#FDECC1');
    }
    // 사용 예정의 데이터인 경우 //
    else if (moment().isBefore(startDate)) {
      setFontColor('#FFFFFF');
      setBorder('1px solid #FFA800');
      setHoverBorder('1px solid #FFA800');
      setBackgroundColor('#FFA800');
    }
    // 사용 기한이 끝나지 않은 경우 //
    else if (moment().isBefore(endDate)) {
      if (data.totalMax !== -1
        && data.totalMax <= data.courseTakeCount
        && (data.lastReserveDate !== undefined && moment().startOf('day').isAfter(data.lastReserveDate))) {
        setFontColor('#777777');
        setBorder('1px solid #F8F8F8');
        setHoverBorder('1px solid #FF8B48');
        setBackgroundColor('#F8F8F8');
      }
      else {
        setFontColor('#595959');
        setBorder('1px solid #FFFFFF');
        setHoverBorder('1px solid #FF8B48');
        setBackgroundColor('#FFFFFF');
      }
    }
    // 예정된 기한이 지난경우 //
    else {
      setFontColor('#777777');
      setBorder('1px solid #F8F8F8');
      setHoverBorder('1px solid #FF8B48');
      setBackgroundColor('#F8F8F8');
    }
  }, [data])

  // 결제 금액 정리 //
  function decideTotalPriceView() {
    if (data.selectedPaymentOptions === undefined || data.selectedPaymentOptions.length === 0) {
      if (data.cardPrice === 0 && data.cashPrice === 0) return t('memberDetail.payFree');
      else if (data.cardPrice === 0) return data.cashPrice.toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCash');
      else if (data.cashPrice === 0) return data.cardPrice.toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCard');
      else return (parseInt(data.cashPrice) + parseInt(data.cardPrice)).toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCombined');
    }
    else {
      const allSame = data.selectedPaymentOptions.every(item => item.name === data.selectedPaymentOptions[0].name);
      const totalPrice = data.selectedPaymentOptions.reduce((sum, item) => sum + item.price, 0);

      const paymentNameMap = { '카드': t('memberDetail.payCard'), '현금': t('memberDetail.payCash'), '포인트': t('memberDetail.payPoint') };
      if (allSame) return totalPrice.toLocaleString('ko-KR') + ' - ' + (paymentNameMap[data.selectedPaymentOptions[0].name] || data.selectedPaymentOptions[0].name);
      else return totalPrice.toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCombined');
    }
  }

  // 남은일수에 맞춰 텍스트 정리 //
  function remainDaysView() {
    if (data.isRefund) return t('memberDetail.statusRefund');
    else if (data.isExpectedMemberShip) return t('memberDetail.statusPaymentPending');
    else if (data.totalMax === data.courseTakeCount
      && (data.lastReserveDate !== undefined && (moment().startOf('day').isAfter(data.lastReserveDate)))) return t('memberDetail.statusExpired');
    else if (moment().isBefore(data.startDate)) return t('memberDetail.statusScheduled');
    else if (moment(moment(data.endDate).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'days') > 0) {
      return moment(moment(data.endDate).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'days') + t('memberDetail.daysSuffix');
    }
    else if (moment(moment(data.endDate).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'days') === 0) {
      return 'D-Day'
    }

    return t('memberDetail.statusExpired');
  }

  // 수강 횟수 표시 //
  function decideUseTotalMax() {
    if (data.totalMax === -1) return data.courseTakeCount + '/∞';
    else return data.courseTakeCount + '/' + data.totalMax;
  }

  return (
    <TopLevelWrapper>
      <MemberShipComponent
        zIndex={20 + size - index}
        border={border}
        hoverBorder={hoverBorder}
        backgroundColor={backgroundColor}
        isPartial={data.isRefund || data.historyData.length > 0}>
      <Table>
        <Body>
          <Tr style={{ width: '301px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '301px', gap: '4px' }}>
                {
                  data.isSubscriptionMembership &&
                  <SubscriptionBox status={data.subscribeStatus && !data.subscribeDeleted}>
                    <SubscriptionText>{(data.subscribeStatus && !data.subscribeDeleted) ? t('memberDetail.statusSubscribing') : t('memberDetail.statusSubscriptionEnded')}</SubscriptionText>
                  </SubscriptionBox>
                }
                <Text color={fontColor}>{data.memberShipName}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '152px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '127px' }}>
                <Text color={fontColor}>
                  {data.startDate.slice(2, 10).replaceAll('-', '.')} ~ {data.endDate.slice(2, 10).replaceAll('-', '.')}
                </Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '164px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '160px' }}>
                <Text color={fontColor}>{decideTotalPriceView()}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '190px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '180px' }}>
                <Text color={fontColor}>{data.notReceivedPrice.toLocaleString('ko-KR')}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '70px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '66px' }}>
                <Text color={fontColor}>{remainDaysView()}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '83px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '53px' }}>
                <Text color={fontColor}>{decideUseTotalMax()}</Text>
              </TextWrapper>
            </Td>
          </Tr>
        </Body>
      </Table>
      </MemberShipComponent>
      {
        data.isRefund &&
        <ExpertComponentWrapper zIndex={data.historyData.length + 1}>
          <PartnerGymRefundInfoView data={data}/>
        </ExpertComponentWrapper>
      }
      {
        data.historyData.map((innerData, index) => (
          <ExpertComponentWrapper key={'PartnerGymHolding-' + index} zIndex={data.historyData.length - index}>
            <PartnerGymHoldingAndExtendHistoryInfoView
              data={innerData} />
          </ExpertComponentWrapper>
        ))
      }
    </TopLevelWrapper>
  )
};

export default PartnerGymMemberShipHistoryInfoView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 1018px;
`;

const MemberShipComponent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 1018px;
  height: 50px;

  box-shadow: 0px 10px 50px rgba(240, 232, 227, 0.5);

  z-index: ${props => props.zIndex};

  border: ${props => props.border};
  border-radius: ${props => props.isPartial ? '30px 10px 0px 30px' : '30px'};
  background-color: ${props => props.backgroundColor};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    border: ${props => props.hoverBorder};
  }
`;

const Table = styled.table`
  display: flex;
  flex-direction: row;
`;

const Body = styled.tbody`
  display: flex;
  flex-direction: row;

  margin-left: 15px;
`;

const Tr = styled.tr`
  display: flex;
  flex-direction: row;
`;

const Td = styled.td`
  display: flex;
  flex-direction: row;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  overflow: hidden;

  max-height: 20px;
`;

const Text = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  padding: 0 0 0 0;
`;

const SubscriptionBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 2px;

  min-width: ${props => props.status ? `40px` : `54px`};
  min-height: 18px;

  border-radius: 5px;
  background-color: ${props => props.status ? `#FF8B48` : `#6DD49E`};
`;

const SubscriptionText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 12px;

  color: #FFFFFF;

  margin: -2px 0 0 0;
  padding: 0 0 0 0;

  &:hover {
    cursor: default;
  }
`;

const ExpertComponentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;

  z-index: ${props => props.zIndex};
`;
